<template>
  <div>
    <div class="p-4 rounded-t">
      <div class="flex items-center">
        <div class="w-1/4 sm:hidden pr-5">
          <img :src="scopeImageUrl" :alt="scopeName" class="w-full">
        </div>
        <div class="w-3/4">
          <div class="text-xs uppercase font-bold">{{permittedCurrentScope.brand.name}}</div>
          <h1 class="uppercase mb-0 text-sm sm:text-xl">{{permittedCurrentScope.name}}</h1>
          <div v-if="permittedCurrentScope">
            <div
              class="bg-primary text-white rounded px-2 mr-2 text-xs inline-block font-bold leading-normal uppercase"
              v-for="modification in permittedCurrentScope.modifications">
              {{modification}}
            </div>
          </div>
          <div v-else>
            <span class="text-sm text-gray-700" v-html='$t("scopePreviewCard.customTurretNotice")'></span>
          </div>
        </div>
      </div>
    </div>
    <div class="border-t items-center sm:flex hidden">
      <div class="w-1/2 mx-auto">
        <div class="px-12 py-2">
          <img :src="scopeImageUrl" :alt="scopeName" class="w-full" />
        </div>
      </div>
      <div v-if="this.permittedCurrentScope" class="w-1/2 border-l">
        <div class="px-12 py-2">
          <img :src="turretImageUrl" :alt="scopeName" class="w-full" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["scopePlaceholderUrl", "currentScope", "currentScopeProductVariant"],
  computed: {
    permittedCurrentScope() {
      if (this.$store) {
        return this.$store.getters["turretCustomizer/permittedCurrentScope"]
      }
      return this.currentScope
    },
    scopeImageUrl() {
      return this.permittedCurrentScope["scope_image_url"]
    },
    scopeName() {
      return `${this.permittedCurrentScope["name"]} ${this.$t("generic.turret")}`
    },
    turretImageUrl() {
      return this.currentScopeProductVariant["image_url"]
    }
  }
}
</script>
